<template>
  <div class="py-2 px-4 caption">
    <table>
      <tbody>
        <tr v-for="dataPoint in dataPoints" :key="dataPoint.icon">
          <td>
            <v-icon
              class="material-icons-outlined"
              size="14"
              :color="dataPoint.color"
            >
              {{ dataPoint.icon }}
            </v-icon>
          </td>
          <td>{{ dataPoint.value }}</td>
          <td>{{ dataPoint.suffix }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ReferenceFile } from '@/models';

const DATA_POINTS = [
  {
    icon: 'article',
    color: 'light-blue lighten-2',
    value: (referenceFile) => referenceFile.recordsParsedCount || 0,
    suffix: 'Total',
  },
  {
    icon: 'add',
    color: 'success',
    value: (referenceFile) => referenceFile.newReferenceCount || 0,
    suffix: 'New',
  },
  {
    icon: 'broken_image',
    color: 'grey darken-2',
    value: (referenceFile) => referenceFile.invalidCount || 0,
    suffix: 'Invalid',
  },
  {
    icon: 'check_circle',
    color: 'teal',
    value: (referenceFile) =>
      referenceFile.autoResolvedDuplicateCount || 0,
    suffix: 'Auto-resolved duplicates',
  },
  {
    icon: 'content_copy',
    color: 'purple',
    value: (referenceFile) =>
      referenceFile.identicalDuplicateCount || 0,
    suffix: 'Identical duplicates',
  },
  {
    icon: 'find_in_page',
    color: 'primary',
    value: (referenceFile) =>
      referenceFile.potentialDuplicateCount || 0,
    suffix: 'Duplicates marked for review',
  },
];

export default {
  name: 'ReferenceProcessingListItemDetails',
  props: {
    referenceFile: {
      type: ReferenceFile,
      required: true,
    },
  },
  computed: {
    dataPoints() {
      return DATA_POINTS.map((dataPoint) => ({
        ...dataPoint,
        value: dataPoint.value(this.referenceFile).toLocaleString(),
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
table td:not(:first-child) {
  padding-left: 12px;
}
table tr:not(:last-child) td {
  padding-bottom: 8px;
}
table tr td:nth-child(2) {
  text-align: center;
}
</style>
